<section data-testid="c360-engagement" class="c360-section">
  <header class="c360-section__head">
    <h2 class="c360-section__title">Engagement</h2>
    <p class="c360-section__subtitle">Whether the people who bought it are using it.</p>
  </header>
  <div class="c360-grid">
    <article data-testid="c360-logins-card" class="c360-card c360-span-8">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">Logins per week</h3>
          <p data-testid="c360-logins-summary" class="c360-card__description">{{ loginsSummary }}</p>
        </div>
      </div>
      <div class="c360-card__body">
        <app-admin-dashboard-empty *ngIf="loaded && !weeks.length" data-testid="c360-logins-empty" icon="fa-regular fa-chart-column"
                                   [title]="'No login history yet'"></app-admin-dashboard-empty>
        <div #chart data-testid="c360-logins-chart" class="c360-chart c360-chart--md" [hidden]="loaded && !weeks.length"></div>
      </div>
    </article>
    <article data-testid="c360-seats-card" class="c360-card c360-span-4">
      <div class="c360-card__head">
        <div>
          <h3 data-testid="c360-seats-title" class="c360-card__title">{{ hasSeatsSeries ? 'Active users against licensed seats' : 'Seats and accounts' }}</h3>
          <p data-testid="c360-seats-subtitle" class="c360-card__description">{{ seatsSubtitle }}</p>
        </div>
      </div>
      <div data-testid="c360-seats-chart-body" class="c360-card__body" [hidden]="!hasSeatsSeries">
        <app-admin-dashboard-empty *ngIf="hasSeatsSeries && seatsCollecting" data-testid="c360-seats-collecting" [compact]="true"
                                   icon="fa-regular fa-chart-column" [title]="'Collecting history'"
                                   [body]="'Active users and seats are recorded each night; the chart fills in as the nightly job runs.'"></app-admin-dashboard-empty>
        <div #seatsChart data-testid="c360-seats-chart" class="c360-chart c360-chart--md" [hidden]="seatsCollecting"></div>
      </div>
      <div *ngIf="!hasSeatsSeries && engagement as e" class="c360-card__body">
        <div class="c360-figure">
          <span data-testid="c360-seats-used" class="c360-figure__value">{{ e.SeatsUsed | number }}</span>
          <span data-testid="c360-seats" class="c360-figure__label">{{ e.SeatsUsed | number }} of {{ e.Seats | adbCount:'seat' }} used</span>
        </div>
        <div data-testid="c360-seats-meter" class="c360-meter"><span class="c360-meter__fill" [style.width.%]="seatShare(e)"></span></div>
        <p data-testid="c360-active-accounts" class="c360-card__description">Active accounts: {{ e.ActiveAccounts }}</p>
      </div>
    </article>
    <article data-testid="c360-users-card" class="c360-card c360-span-12">
      <div class="c360-card__head">
        <div>
          <h3 class="c360-card__title">Users</h3>
          <p data-testid="c360-users-subtitle" class="c360-card__description">{{ usersSubtitle }}</p>
        </div>
      </div>
      <div class="c360-card__body">
        <ng-container *ngIf="hasUsers; else topUsers">
          <app-admin-dashboard-empty *ngIf="!engagement.Users.length" data-testid="c360-users-empty" [compact]="true"
                                     icon="fa-regular fa-user" [title]="'No users yet'"></app-admin-dashboard-empty>
          <table *ngIf="engagement.Users.length" data-testid="c360-users-table" class="c360-table">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col">Role</th>
                <th scope="col" class="c360-num">Logins, 30 days</th>
                <th scope="col" class="c360-num">Last active</th>
                <th scope="col" class="c360-num">Joined</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of shownUsers" data-testid="c360-user-row">
                <td>
                  <span data-testid="c360-user-name" class="c360-user__name">{{ user.name || user.email }}</span>
                  <span *ngIf="user.name" data-testid="c360-user-email" class="c360-user__email">{{ user.email }}</span>
                </td>
                <td data-testid="c360-user-role">{{ user.role || '–' }}</td>
                <td data-testid="c360-user-logins" class="c360-num">{{ user.logins30 ? (user.logins30 | number) : '–' }}</td>
                <td data-testid="c360-user-last-active" class="c360-num" [class.c360-warn]="isStale(user)">{{ lastActiveText(user) }}</td>
                <td data-testid="c360-user-joined" class="c360-num">{{ user.joined ? (user.joined | date:'d MMM y':'UTC') : '–' }}</td>
              </tr>
            </tbody>
          </table>
          <button *ngIf="engagement.Users.length > usersShown" type="button" data-testid="c360-users-toggle" class="c360-users__toggle"
                  (click)="allUsers = !allUsers">{{ usersToggleText }}</button>
        </ng-container>
        <ng-template #topUsers>
          <app-admin-dashboard-empty *ngIf="engagement && !engagement.TopUsers?.length" data-testid="c360-users-empty" [compact]="true"
                                     icon="fa-regular fa-user" [title]="'No logins in the last 30 days'"></app-admin-dashboard-empty>
          <table *ngIf="engagement?.TopUsers?.length" class="c360-table">
            <thead>
              <tr>
                <th scope="col">User</th>
                <th scope="col" class="c360-num">Logins, 30 days</th>
                <th scope="col" class="c360-num">Last login</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of engagement.TopUsers" data-testid="c360-user-row">
                <td class="c360-table__name">{{ user.email }}</td>
                <td class="c360-num">{{ user.logins | number }}</td>
                <td class="c360-num">{{ user.lastLogin | date:'d MMM y, HH:mm':'UTC' }}</td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </article>
  </div>
</section>
